import classnames from 'classnames';
import CenteredContent from '@picsart/rc/old/CenteredContent';
import FooterRelevantLinks from '../../FooterRelevantLinks/index.js';
import { createUseStyles } from 'react-jss';
import AnalyticsService from '@picsart/rc/services/analytics';
import footerNavigation from '../../footerNavigation/index.js';
import { u as useAuthContext } from '../../authContext-fe8fc8dc.js';
import { useTranslator } from '@picsart/rc/services/localization';
import IllustrationAICPA from '@picsart/illustrations/IllustrationAICPA';
import { L as LogoAndLanguageSwitcher, C as CopyRight } from '../../CopyRight-a9a10613.js';
import { s as socialIcons } from '../../socialIcons-13793a15.js';
import navigationItems from '../../navigationItems/index.js';
import { _ as _defineProperty } from '../../defineProperty-377d5a7f.js';
import { isLeftToRight, isRightToLeft } from '@picsart/cascade/styleHelpers/rtl';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import textOverflowHidden from '@picsart/cascade/styleHelpers/textOverflowHidden';
import { useMemo, useRef, useState, useEffect } from 'react';
import { canHover, canTouch } from '@picsart/cascade/styleHelpers/hoverTouch';
import mediaQuery from '@picsart/cascade/styleHelpers/mediaQuery';
import { BreakPoints } from '@picsart/cascade/responsive';
import { e as externalLinksData, c as changesNeedLocales } from '../../constants-058c946f.js';
import '@picsart/cascade/styleHelpers/initFavIcons';
import { t as theme } from '../../styles-2f14f8fb.js';
import '@picsart/rc/useMount';
import '@picsart/cascade/colors/themes';
import { _ as _slicedToArray } from '../../slicedToArray-b4278ecd.js';
import useGeoZone from '../../useGeozone/index.js';
import footerLegalNavigation from '../../footerLegalNavigation/index.js';
import { R as RestrictedGeoZones } from '../../constants-d756cbb3.js';
import IconArrowDownFilled from '@picsart/icons/IconArrowDownFilled';
import useClickOutside from '@picsart/rc/useClickOutside';
import onFocusTrapping from '@picsart/rc/onFocusTrapping';

var useStyles$9 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings;
  return {
    root: {
      width: '100%',
      minWidth: 1024,
      textDecoration: 'none'
    },
    section: {
      '&.top': {
        padding: [spacings.s44, spacings.s4, spacings.s56, spacings.s0],
        // TODO replace when this color is refined
        backgroundColor: '#282B36'
      },
      '&.bottom': {
        padding: [spacings.s24, spacings.s0],
        // TODO replace when this color is refined
        backgroundColor: '#1E2129'
      }
    }
  };
}, {
  name: 'rc-footer'
});

var useStyles$8 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    colors = _ref.colors,
    lineHeights = _ref.lineHeights;
  return {
    logoLink: {
      display: 'inline-block',
      verticalAlign: 'top',
      height: 24,
      fontSize: 0
    },
    platforms: {
      display: 'block',
      marginTop: spacings.s8
    },
    '::slotted(img)': {
      display: 'none'
    },
    platformItem: _defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top',
      '&::shadow': {
        display: 'none'
      }
    }, isLeftToRight(), {
      marginRight: spacings.s12
    }), isRightToLeft(), {
      marginLeft: spacings.s12
    }), '&:last-child', {
      margin: spacings.s0
    }),
    getTheApp: {
      display: 'block',
      fontWeight: fontWeights.SemiBold,
      fontSize: fontSizes.s14,
      color: colors.texts.positive,
      textTransform: 'uppercase',
      marginTop: spacings.s32,
      lineHeight: lineHeights.l28
    },
    platformLink: {
      '& :host ': {
        backgroundColor: colors.statuses.error.base.action
      },
      display: 'block',
      height: 32,
      fontSize: 0,
      '& > .apple': {
        width: 91
      },
      '& > .google': {
        width: 103
      },
      '& > .microsoft': {
        width: 88
      }
    },
    platformIcon: {
      display: 'inline-block',
      verticalAlign: 'top',
      width: '100%',
      height: '100%'
    },
    aicpaIcon: {
      display: 'block',
      marginTop: spacings.s24,
      width: 70,
      height: 70,
      '& > svg': {
        width: '100%',
        height: '100%'
      }
    }
  };
}, {
  name: 'app-column'
});

var storeData = {
  store: 'microsoft_store',
  microsoft: 'microsoft'
};

function AppsColumn(_ref) {
  var analyticsSource = _ref.analyticsSource,
    isSingleLanguage = _ref.isSingleLanguage;
  var styles = useStyles$8();
  var translate = useTranslator();
  var handleStoreClick = function handleStoreClick(e) {
    if (analyticsSource) {
      AnalyticsService.sendEvent('store_button_click', {
        source: analyticsSource,
        store_name: e.currentTarget.getAttribute('store-name')
      });
    }
  };
  var handleSocialEvents = function handleSocialEvents(subCategory) {
    AnalyticsService.sendEvent('page_click', {
      component: 'footer',
      category: 'get_free_app',
      sub_category: subCategory,
      action_button: ''
    });
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(LogoAndLanguageSwitcher, {
      isMobile: false,
      isSingleLanguage: isSingleLanguage
    }), /*#__PURE__*/jsx("span", {
      className: styles.getTheApp,
      "data-test": "get-free-app-hypertext",
      children: translate('GET THE FREE APP')
    }), /*#__PURE__*/jsx("ul", {
      className: styles.platforms,
      children: socialIcons.map(function (el) {
        var _el$component;
        var AppStoreLinkIllustration = (_el$component = el === null || el === void 0 ? void 0 : el.component) !== null && _el$component !== void 0 ? _el$component : /*#__PURE__*/jsx(Fragment, {});
        return /*#__PURE__*/jsx("li", {
          className: styles.platformItem,
          onClick: function onClick() {
            return handleSocialEvents(el.storeName === "".concat(storeData.store) ? "".concat(storeData.microsoft) : el.storeName);
          },
          children: /*#__PURE__*/jsxs("a", {
            className: styles.platformLink,
            href: el.url,
            "store-name": el.storeName,
            onClick: handleStoreClick,
            "data-test": el.dataTest,
            "aria-label": el.ariaLabel,
            tabIndex: 0,
            children: [/*#__PURE__*/jsx(AppStoreLinkIllustration, {
              className: classnames(styles.platformIcon, el.extensionClassName),
              fill: "none"
            }), translate(el.label)]
          })
        }, el.label);
      })
    }), /*#__PURE__*/jsx("a", {
      href: "".concat(navigationItems.aicpa.url),
      className: styles.aicpaIcon,
      children: /*#__PURE__*/jsx(IllustrationAICPA, {
        "aria-label": "AICPA SOC compliance logo"
      })
    })]
  });
}

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$7 = createUseStyles(function (_ref) {
  var fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    lineHeights = _ref.lineHeights,
    colors = _ref.colors;
  return {
    root: _objectSpread$1({
      display: 'block',
      fontWeight: fontWeights.SemiBold,
      fontSize: fontSizes.s14,
      color: colors.texts.positive,
      lineHeight: lineHeights.l24,
      textTransform: 'uppercase'
    }, textOverflowHidden)
  };
}, {
  name: 'title-column'
});

function ColumnTitle(_ref) {
  var label = _ref.label;
  var styles = useStyles$7();
  var translate = useTranslator();
  return /*#__PURE__*/jsx("strong", {
    className: styles.root,
    children: translate(label)
  });
}

var useStyles$6 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    lineHeights = _ref.lineHeights,
    timings = _ref.timings,
    easings = _ref.easings,
    colors = _ref.colors;
  return {
    root: {
      display: 'block',
      marginTop: spacings.s6
    },
    item: _defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top',
      marginTop: spacings.s6
    }, isLeftToRight(), {
      marginRight: spacings.s16
    }), isRightToLeft(), {
      marginLeft: spacings.s16
    }),
    link: _defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top',
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s14,
      color: colors.statuses.positive.base.action,
      lineHeight: lineHeights.l24,
      transition: "color ".concat(timings.Default, " ").concat(easings.EaseInOut),
      cursor: 'pointer'
    }, canHover(), {
      '&:hover': {
        color: colors.texts.positive
      }
    }), canTouch(), {
      '&:active': {
        color: colors.texts.positive
      }
    }), '&:not(:hover):focus', {
      color: colors.texts.positive
    })
  };
}, {
  name: 'links-list'
});

function LinksList(_ref) {
  var groupList = _ref.groupList,
    handleEvent = _ref.handleEvent,
    label = _ref.label;
  var styles = useStyles$6();
  var translate = useTranslator();
  var category = useMemo(function () {
    return label === null || label === void 0 ? void 0 : label.toLocaleLowerCase().replace(/ /g, '_');
  }, [label]);
  return /*#__PURE__*/jsx("ul", {
    className: styles.root,
    children: groupList.map(function (item) {
      var subCategory = item.label.toLocaleLowerCase().replace(/ /g, '_');
      var finalCategory = subCategory === 'picsart_editor' || subCategory === 'photo_editor' ? "web_".concat(subCategory) : subCategory;
      return /*#__PURE__*/jsx("li", {
        className: styles.item,
        onClick: function onClick() {
          return handleEvent && handleEvent(category, finalCategory);
        },
        children: /*#__PURE__*/jsx("a", {
          className: styles.link,
          href: item.url,
          "data-test": item.dataTest,
          tabIndex: 0,
          children: translate(item.label)
        })
      }, item.label);
    })
  });
}

var useStyles$5 = createUseStyles(function (_ref) {
  _ref.spacings;
    _ref.colors;
  return {
    root: {
      minWidth: '100%',
      maxWidth: '100%',
      '&.first': _defineProperty({
        width: 480
      }, mediaQuery(BreakPoints.Large), {
        width: 380
      })
    }
  };
}, {
  name: 'top-grid-col'
});

function TopGridColumn(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var styles = useStyles$5();
  return /*#__PURE__*/jsx("div", {
    className: classnames(styles.root, className),
    children: children
  });
}

var useStyles$4 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings;
  return {
    root: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr 1fr 1fr',
      gridTemplateRows: '12fr',
      gridColumnGap: spacings.s24
    }
  };
}, {
  name: 'top-grid'
});

function TopGrid(_ref) {
  var analyticsSource = _ref.analyticsSource,
    isSingleLanguage = _ref.isSingleLanguage;
  var styles = useStyles$4();
  var _useAuthContext = useAuthContext(),
    user = _useAuthContext.user;
  var isLoggedIn = !!user;
  var handleFooterEvents = function handleFooterEvents(category, subCategory) {
    AnalyticsService.sendEvent('page_click', {
      component: 'footer',
      category: category,
      sub_category: subCategory,
      action_button: '',
      is_logged: isLoggedIn
    });
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/jsx(TopGridColumn, {
      className: "first",
      children: /*#__PURE__*/jsx(AppsColumn, {
        analyticsSource: analyticsSource,
        isMobile: false,
        isSingleLanguage: isSingleLanguage
      })
    }), footerNavigation.map(function (el) {
      return el.groupLabel !== 'Legal' && /*#__PURE__*/jsxs(TopGridColumn, {
        children: [/*#__PURE__*/jsx(ColumnTitle, {
          label: el.groupLabel
        }), /*#__PURE__*/jsx(LinksList, {
          groupList: el.groupList || [],
          handleEvent: handleFooterEvents,
          label: el.groupLabel
        })]
      }, el.groupLabel);
    })]
  });
}

var useStyles$3 = createUseStyles(function (_ref) {
  var radiuses = _ref.radiuses,
    spacings = _ref.spacings,
    colors = _ref.colors,
    timings = _ref.timings,
    easings = _ref.easings;
  return {
    link: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top',
      width: 24,
      height: 24,
      borderRadius: radiuses.circle,
      fontSize: 0,
      // TODO replace when this color is refined
      backgroundColor: '#32343b',
      position: 'relative',
      cursor: 'pointer'
    }, isLeftToRight(), {
      marginRight: spacings.s12
    }), isRightToLeft(), {
      marginLeft: spacings.s12
    }), canHover(), {
      '&:hover': {
        '& > svg': {
          transition: "fill ".concat(timings.Default, " ").concat(easings.EaseInOut),
          fill: colors.accents.primary.base["default"]
        }
      }
    }), canTouch(), {
      '&:active': {
        '& > $icon': {
          '& > svg': {
            '& > path': {
              fill: colors.accents.primary.base["default"]
            }
          }
        }
      }
    }), '&:not(:hover):focus', {
      '& > $icon': {
        '& > svg': {
          '& > path': {
            fill: colors.accents.primary.base["default"]
          }
        }
      }
    }), '&:last-child', {
      margin: spacings.s0
    }),
    icon: {
      display: 'inline-block',
      width: 16,
      height: 16,
      position: 'absolute',
      top: spacings.s0,
      right: spacings.s0,
      bottom: spacings.s0,
      left: spacings.s0,
      margin: 'auto',
      '& > svg': {
        '& > path': {
          transition: "fill ".concat(timings.Default, " ").concat(easings.EaseInOut),
          fill: colors.texts.positive
        }
      }
    }
  };
}, {
  name: 'external-links'
});

function ExternalLinks() {
  var styles = useStyles$3();
  return /*#__PURE__*/jsx(Fragment, {
    children: externalLinksData.map(function (item) {
      var _item$component;
      var SocialCascadeIcon = (_item$component = item === null || item === void 0 ? void 0 : item.component) !== null && _item$component !== void 0 ? _item$component : /*#__PURE__*/jsx(Fragment, {});
      return /*#__PURE__*/jsxs("a", {
        className: styles.link,
        href: item.url,
        "data-test": item.dataTest,
        "aria-label": item.ariaLabel,
        target: "_blank",
        rel: "noreferrer noopener",
        tabIndex: 0,
        children: [/*#__PURE__*/jsx(SocialCascadeIcon, {
          "aria-hidden": true,
          className: styles.icon,
          fill: theme.colors.texts.positive
        }), item.name]
      }, item.name);
    })
  });
}

var useStyles$2 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    fontSizes = _ref.fontSizes,
    fontWeights = _ref.fontWeights,
    lineHeights = _ref.lineHeights,
    radiuses = _ref.radiuses,
    colors = _ref.colors,
    timings = _ref.timings,
    easings = _ref.easings;
  return {
    root: {
      position: 'relative'
    },
    button: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top',
      position: 'relative',
      borderRadius: radiuses.r4,
      border: 'none',
      backgroundColor: 'transparent',
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s12,
      color: colors.statuses.positive.base.action,
      lineHeight: lineHeights.l24,
      transitionProperty: 'background-color, color',
      transitionDuration: timings.Default,
      transitionTimingFunction: easings.EaseInOut,
      cursor: 'pointer'
    }, isLeftToRight(), {
      padding: [spacings.s2, spacings.s24, spacings.s2, spacings.s8]
    }), isRightToLeft(), {
      padding: [spacings.s2, spacings.s8, spacings.s2, spacings.s24]
    }), canHover(), {
      '&:hover': {
        // TODO replace when this color is refined
        backgroundColor: '#282B36',
        color: colors.texts.positive,
        '& > $icon': {
          fill: colors.backgrounds.tint3,
          '& > svg': {
            '& > path': {
              fill: colors.texts.positive
            }
          }
        }
      }
    }), canTouch(), {
      '&:active': {
        // TODO replace when this color is refined
        backgroundColor: '#282B36',
        color: colors.texts.positive,
        '& > $icon': {
          '& > svg': {
            '& > path': {
              fill: colors.texts.positive
            }
          }
        }
      }
    }), '&.active', {
      // TODO replace when this color is refined
      backgroundColor: '#282B36',
      color: colors.texts.positive,
      '& > $icon': {
        transform: 'rotate(180deg)',
        '& > svg': {
          '& > path': {
            fill: colors.texts.positive
          }
        }
      }
    }), '&:not(:hover):focus', {
      // TODO replace when this color is refined
      backgroundColor: '#282B36',
      color: colors.texts.positive,
      '& > $icon': {
        '& > svg': {
          '& > path': {
            fill: colors.texts.positive
          }
        }
      }
    }),
    icon: _defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      width: 12,
      height: 12,
      position: 'absolute',
      top: spacings.s0,
      bottom: spacings.s0,
      margin: ['auto', spacings.s0],
      transition: "transform ".concat(timings.Default, " ").concat(easings.EaseInOut)
    }, isLeftToRight(), {
      right: spacings.s4
    }), isRightToLeft(), {
      left: spacings.s4
    }), '& > svg', {
      '& > path': {
        fill: 'var(--statuses-positive-base-action)',
        transition: "fill ".concat(timings.Default, " ").concat(easings.EaseInOut)
      }
    }),
    '@keyframes fade-in': {
      '0%': {
        opacity: 0,
        transform: "translateY(".concat(spacings.s40, ")")
      },
      '100%': {
        opacity: 1,
        transform: "translateY(".concat(spacings.s0, ")")
      }
    },
    list: _defineProperty(_defineProperty({
      display: 'inline-block',
      minWidth: 272,
      padding: spacings.s32,
      border: "1px solid ".concat(colors.markets.base.active),
      borderRadius: radiuses.r8,
      backgroundColor: colors.backgrounds.positive,
      // TODO replace when this color is refined
      boxShadow: '0px 8px 12px #1E2129',
      position: 'absolute',
      bottom: spacings.s56,
      animation: "$fade-in ".concat(timings.Default, " ").concat(easings.EaseInOut, " forwards")
    }, isLeftToRight(), {
      left: spacings.s0
    }), isRightToLeft(), {
      right: spacings.s0
    }),
    item: {
      marginBottom: spacings.s12,
      '&:last-child': {
        marginBottom: spacings.s0
      }
    },
    link: _defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top',
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s14,
      // TODO replace when this color is refined
      color: colors.texts.negative,
      transition: "color ".concat(timings.Default, " ").concat(easings.EaseInOut),
      cursor: 'pointer'
    }, canHover(), {
      '&:hover': {
        color: colors.texts.tint1
      }
    }), canTouch(), {
      '&:active': {
        color: colors.texts.tint1
      }
    }), '&:not(:hover):focus', {
      color: colors.texts.tint1
    })
  };
}, {
  name: 'rc-footer-minimized-links-list'
});

function MinimizedLinksList(_ref) {
  var footerLegalNavigationData = _ref.footerLegalNavigationData,
    handleSecFooterEvents = _ref.handleSecFooterEvents;
  var styles = useStyles$2();
  var translate = useTranslator();
  var subMenuRef = useRef(null);
  var buttonRef = useRef(null);
  var focusableItems = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    listIsVisible = _useState2[0],
    setListIsVisible = _useState2[1];
  var toggleList = function toggleList(e) {
    e.stopPropagation();
    handleSecFooterEvents('more');
    setListIsVisible(!listIsVisible);
  };
  useClickOutside(subMenuRef, function () {
    return setListIsVisible(false);
  });
  useEffect(function () {
    if (listIsVisible && subMenuRef.current) {
      var _focusableItems$curre;
      focusableItems.current = Array.from(subMenuRef.current.querySelectorAll('a'));
      (_focusableItems$curre = focusableItems.current) === null || _focusableItems$curre === void 0 || (_focusableItems$curre = _focusableItems$curre[0]) === null || _focusableItems$curre === void 0 || _focusableItems$curre.focus();
    }
  }, [listIsVisible, subMenuRef, focusableItems]);
  var handleButtonKeyDown = function handleButtonKeyDown(e) {
    if (e.code === 'Enter') {
      e.preventDefault();
      setListIsVisible(true);
    }
  };
  var handleMoreSectionEvents = function handleMoreSectionEvents(action) {
    AnalyticsService.sendEvent('page_click', {
      component: 'footer',
      category: 'secondary_footer',
      sub_category: 'more',
      action_button: action
    });
  };
  var handleMenuKeyDown = function handleMenuKeyDown(e) {
    if (e.code === 'Tab') {
      onFocusTrapping(e, focusableItems.current);
    } else if (e.code === 'Escape') {
      buttonRef.current.focus();
      setListIsVisible(false);
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/jsxs("button", {
      className: classnames(styles.button, {
        active: listIsVisible
      }),
      type: "button",
      onClick: toggleList,
      ref: buttonRef,
      tabIndex: 0,
      onKeyDown: handleButtonKeyDown,
      "data-testid": "footer-more-links-button",
      children: [translate('More'), /*#__PURE__*/jsx(IconArrowDownFilled, {
        fill: theme.colors.statuses.positive.base.action,
        className: styles.icon,
        onClick: function onClick() {
          return handleSecFooterEvents('more');
        },
        "aria-hidden": true
      })]
    }), listIsVisible && /*#__PURE__*/jsx("div", {
      "data-testid": "footer-more-links-popup",
      className: styles.list,
      ref: subMenuRef,
      onKeyDown: handleMenuKeyDown,
      children: Object.keys(footerLegalNavigationData).slice(3).map(function (item, index) {
        var action = footerLegalNavigation[item].label.toLocaleLowerCase().replace(/ /g, '_');
        return /*#__PURE__*/jsx("div", {
          "data-testid": "footer-more-links-item-".concat(index),
          className: styles.item,
          onClick: function onClick() {
            return handleMoreSectionEvents(action.replace(/-/g, '_'));
          },
          onKeyDown: function onKeyDown() {
            return handleMoreSectionEvents(action.replace(/-/g, '_'));
          },
          children: /*#__PURE__*/jsx("a", {
            className: styles.link,
            href: footerLegalNavigationData[item].url,
            tabIndex: 0,
            children: translate(footerLegalNavigationData[item].label)
          })
        }, footerLegalNavigationData[item].label);
      })
    })]
  });
}

var useStyles$1 = createUseStyles(function (_ref) {
  var spacings = _ref.spacings,
    fontWeights = _ref.fontWeights,
    fontSizes = _ref.fontSizes,
    lineHeights = _ref.lineHeights,
    colors = _ref.colors,
    timings = _ref.timings,
    easings = _ref.easings;
  return {
    // TODO Need to set correct type
    root: function root(_ref2) {
      var isUs = _ref2.isUs;
      return {
        display: isUs ? 'block' : 'flex',
        alignItems: 'center',
        maxWidth: isUs ? 400 : '100%'
      };
    },
    item: _defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      verticalAlign: 'top'
    }, isLeftToRight(), {
      marginRight: spacings.s12
    }), isRightToLeft(), {
      marginLeft: spacings.s12
    }), '&:last-child', {
      margin: spacings.s0
    }),
    link: _defineProperty(_defineProperty(_defineProperty({
      display: 'inline-block',
      fontWeight: fontWeights.Medium,
      fontSize: fontSizes.s12,
      color: colors.statuses.positive.base.action,
      lineHeight: lineHeights.l24,
      transition: "color ".concat(timings.Default, " ").concat(easings.EaseInOut),
      cursor: 'pointer'
    }, canHover(), {
      '&:hover': {
        color: colors.texts.positive
      }
    }), canTouch(), {
      '&:active': {
        color: colors.texts.positive
      }
    }), '&:not(:hover):focus', {
      color: colors.texts.positive
    })
  };
}, {
  name: 'rc-footer-minimized-links'
});

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function MinimizedLinks(_ref) {
  var _footerNavItems$ethyc2;
  var countryCode = _ref.countryCode;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    country = _useState2[0],
    setCountry = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    korea = _useState4[0],
    setKorea = _useState4[1];
  useGeoZone(function (geoZone) {
    setCountry(geoZone);
    setKorea(geoZone === RestrictedGeoZones.SouthKorea);
  });
  var styles = useStyles$1({
    isUs: changesNeedLocales.includes(country)
  });
  var translate = useTranslator();
  var _useState5 = useState(footerLegalNavigation),
    _useState6 = _slicedToArray(_useState5, 2),
    footerNavItems = _useState6[0],
    setFooterNavItems = _useState6[1];
  var handleSecFooterEvents = function handleSecFooterEvents(subCategory) {
    AnalyticsService.sendEvent('page_click', {
      component: 'footer',
      category: 'secondary_footer',
      sub_category: subCategory,
      action_button: ''
    });
  };
  useEffect(function () {
    // ToDo Needs to be refactored and use footerNavItems globally
    if (country && changesNeedLocales.includes(country)) {
      var _footerNavItems$ethyc;
      if ((_footerNavItems$ethyc = footerNavItems.ethyca) !== null && _footerNavItems$ethyc !== void 0 && (_footerNavItems$ethyc = _footerNavItems$ethyc.localisedLabels) !== null && _footerNavItems$ethyc !== void 0 && _footerNavItems$ethyc[country]) {
        var newLabel = footerNavItems.ethyca.localisedLabels[country];
        setFooterNavItems(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            ethyca: _objectSpread(_objectSpread({}, prevState.ethyca), {}, {
              label: newLabel
            })
          });
        });
      }
    }
  }, [country, footerNavItems === null || footerNavItems === void 0 || (_footerNavItems$ethyc2 = footerNavItems.ethyca) === null || _footerNavItems$ethyc2 === void 0 ? void 0 : _footerNavItems$ethyc2.localisedLabels]);
  return /*#__PURE__*/jsxs("ul", {
    className: styles.root,
    "data-testid": "footer-legal-navigation-desktop",
    children: [Object.keys(footerNavItems).slice(0, 3).map(function (item, index) {
      var subCategory = footerNavItems[item].label.toLocaleLowerCase().replace(/ /g, '_');
      var urlWithCountryCode = countryCode && footerNavItems[item].withCountryCode ? "/".concat(countryCode) : '';
      var koreaLink = footerNavItems[item].label === 'Privacy Policy' && korea;
      return /*#__PURE__*/jsx("li", {
        "data-testid": "footer-links-".concat(index),
        className: styles.item,
        onClick: function onClick() {
          return handleSecFooterEvents(subCategory);
        },
        onKeyDown: function onKeyDown() {
          return handleSecFooterEvents(subCategory);
        },
        children: /*#__PURE__*/jsx("a", {
          className: classnames(styles.link, koreaLink && 'korea-link'),
          href: "".concat(urlWithCountryCode).concat(footerNavItems[item].url),
          "data-test": footerNavItems[item].dataTest,
          tabIndex: 0,
          children: koreaLink ? '개인정보 처리방침' : translate(footerNavItems[item].label)
        })
      }, item);
    }), /*#__PURE__*/jsx("li", {
      className: styles.item,
      children: /*#__PURE__*/jsx(MinimizedLinksList, {
        footerLegalNavigationData: footerNavItems,
        handleSecFooterEvents: handleSecFooterEvents
      })
    })]
  });
}

var useStyles = createUseStyles(function (_ref) {
  var spacings = _ref.spacings;
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      minHeight: 24
    },
    aside: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    center: {
      display: 'inline-block',
      position: 'absolute',
      top: spacings.s0,
      left: '50%',
      transform: 'translateX(-50%)'
    }
  };
}, {
  name: 'bottom-grid'
});

function BottomGrid(_ref) {
  var countryCode = _ref.countryCode;
  var styles = useStyles();
  return /*#__PURE__*/jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/jsx("div", {
      className: classnames(styles.aside, 'left'),
      children: /*#__PURE__*/jsx(MinimizedLinks, {
        countryCode: countryCode
      })
    }), /*#__PURE__*/jsx("div", {
      className: styles.center,
      children: /*#__PURE__*/jsx(ExternalLinks, {})
    }), /*#__PURE__*/jsx("div", {
      className: classnames(styles.aside, 'right'),
      children: /*#__PURE__*/jsx(CopyRight, {})
    })]
  });
}

function Desktop(_ref) {
  var analyticsSource = _ref.analyticsSource,
    countryCode = _ref.countryCode,
    isSingleLanguage = _ref.isSingleLanguage,
    _ref$relevantLinkEnab = _ref.relevantLinkEnabled,
    relevantLinkEnabled = _ref$relevantLinkEnab === void 0 ? true : _ref$relevantLinkEnab;
  var styles = useStyles$9();
  return /*#__PURE__*/jsxs("div", {
    children: [relevantLinkEnabled && /*#__PURE__*/jsx(FooterRelevantLinks, {}), /*#__PURE__*/jsxs("footer", {
      className: styles.root,
      id: "footer-desktop",
      "data-testid": "footer-desktop",
      children: [/*#__PURE__*/jsx("section", {
        className: classnames(styles.section, 'top'),
        children: /*#__PURE__*/jsx(CenteredContent, {
          children: /*#__PURE__*/jsx(TopGrid, {
            analyticsSource: analyticsSource,
            isSingleLanguage: isSingleLanguage
          })
        })
      }), /*#__PURE__*/jsx("section", {
        className: classnames(styles.section, 'bottom'),
        children: /*#__PURE__*/jsx(CenteredContent, {
          children: /*#__PURE__*/jsx(BottomGrid, {
            countryCode: countryCode
          })
        })
      })]
    })]
  });
}

export { MinimizedLinks, Desktop as default };
//# sourceMappingURL=index.js.map
